import React, { Component } from "react";
import PropTypes from "prop-types";

import i18n from "i18n-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HashLink as Link } from "react-router-hash-link";
import { Spring } from "react-spring";
import SweetAlert from "sweetalert-react";
import { renderToString } from "react-dom/server";

import {
  APIHandler,
  StorageHandler,
  BackVideo,
  DataHandler,
  StoreButtons,
  LanguageSelect,
  SharingPopup,
  NotificationSlider,
} from "C4";
import { storageKeys, bgVideo } from "settings";

import Logo from "assets/images/logo/logo.png";

const getTotalProgress = (chapters) => {
  return chapters
    .slice(0, 5)
    .reduce((sum, chapter) => sum + chapter.progress, 0);
};

const getTotalPages = (chapters) => {
  return chapters
    .slice(0, 5)
    .reduce((sum, chapter) => sum + (chapter.total_pages - 1), 0);
};

const calculateProgressPercentage = (progress, pages) => {
  return Math.floor((progress / pages) * 100);
};

const fetchUserProgress = async (email, appId) => {
  const userProgress = await APIHandler.getUserProgress(appId, email);
  return userProgress;
};

const fancyOptions = (url) => {
  return {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: "y",
    },
    buttons: ["share", "close"],
    caption: "",
    share: {
      tpl: renderToString(<SharingPopup url={url} />),
    },
  };
};

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: "",
      unreadMessageCount: 0,
      lastCheckedMessages: "",
      appId: -1,
      userStatus: "startTraining",
      noAgent: false,
      trainingComplete: false,
      offers: false,
      totalProgressValue: 0,
    };
  }

  componentWillMount() {
    document.body.classList.add("no-scroll");
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = (val) => `0${val}`.slice(-2);

    this.updateUserProgress();

    StorageHandler.load(storageKeys.user).then((user) => {
      if (user && user.sales_companion_registered === null) {
        const obj = user;
        const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(
          d.getDate()
        )}`;
        DataHandler.matchAppId().then((appId) => {
          APIHandler.updateUser(appId, obj.email, [
            { param: "sales_companion_registered", val: date },
          ]).then((res) => {
            if (res) {
              obj.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        });
      }
    });
    DataHandler.matchAppId().then((appId) => {
      this.setState({ appId });
      StorageHandler.exists(storageKeys.announcement).then(
        (announcementShownBefore) => {
          if (!announcementShownBefore) {
            APIHandler.getAnnouncement(appId).then((res) => {
              if (res && res[0] && res[0].message && res.length !== 0) {
                let TaostContent = () => (
                  <div>
                    <a
                      href={res[0].weblink}
                      data-fancybox={res[0].weblink}
                      data-options={JSON.stringify(
                        fancyOptions(res[0].weblink)
                      )}
                    >
                      <p dangerouslySetInnerHTML={{ __html: res[0].message }} />
                    </a>
                  </div>
                );

                if (!res[0].weblink) {
                  <div>
                    <p dangerouslySetInnerHTML={{ __html: res[0].message }} />
                  </div>;
                }
              }
              return null;
            });
          }
        }
      );
    });

    this.getUser();
  }

  updateUserProgress = async () => {
    try {
      const res = await StorageHandler.load(storageKeys.user);
      if (res) {
        const { email } = res;
        const appId = await DataHandler.matchAppId();
        const userProgress = await fetchUserProgress(email, appId);
        if (userProgress && userProgress.data && userProgress.data[0]) {
          const chapters = userProgress.data[0].chapters;
          const totalProgress = getTotalProgress(chapters);
          const totalPages = getTotalPages(chapters);
          const percentage = calculateProgressPercentage(
            totalProgress,
            totalPages
          );
          console.log(percentage);
          if (percentage >= 100) {
            this.setState({
              totalProgressValue: percentage >= 100 ? 100 : percentage,
              userStatus: "graduated",
            });

            // API call to grad user
            this.graduateUser();
          }
        }
      }
    } catch (error) {
      console.error("Error updating user progress:", error);
    }
  };

  graduateUser() {
    const d = new Date(Date.now());
    const leading = (val) => `0${val}`.slice(-2);
    StorageHandler.load(storageKeys.user).then((user) => {
      const obj = user;
      console.log(obj);
      if (obj.training_graduated === null) {
        const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(
          d.getDate()
        )}`;
        APIHandler.updateUser(appId, obj.email, [
          { param: "sales_companion_registered", val: date },
          { param: "training_started", val: date },
          { param: "training_graduated", val: date },
        ]).then((res) => {});
      }
    });
  }

  componentWillUnmount() {
    document.body.classList.remove("no-scroll");
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  checkForUnreadMessages() {
    DataHandler.requestWithId(
      APIHandler.getUnreadMessages,
      this.state.lastCheckedMessages
    ).then((res) => {
      if (res && res.missed_items && res.missed_items[0]) {
        this.setState({ unreadMessageCount: res.missed_items[0].count });
      }
    });
  }

  openPopup() {
    this.setState({ offers: true });
  }

  closePopup() {
    this.setState({ offers: false });
  }

  getUserProgress() {
    StorageHandler.load(storageKeys.user).then((user) =>
      DataHandler.matchAppId().then((appId) => {
        APIHandler.getUserProgress(appId, user.email).then((res) => {
          if (res && res.data && res.data[0] && res.data[0].chapters) {
            const allChapters = res.data[0].chapters;
            const numOfChapters = allChapters.length;
            let totalProgress = 0;
            allChapters.forEach((chapter) => {
              const chapterProgress = Math.floor(
                (100 / (chapter.total_pages - 1)) * chapter.progress
              );
              totalProgress += chapterProgress;
            });

            if (totalProgress >= numOfChapters * 100) {
              this.setState({
                trainingComplete: true,
              });
            }
          }
        });
      })
    );
  }

  getUser() {
    StorageHandler.load(storageKeys.user).then((user) =>
      DataHandler.matchAppId().then((appId) => {
        APIHandler.getUserOld(appId, user.email).then((res) => {
          console.log(res);
          if (res && res.response) {
            if (res.response.training_graduated) {
              this.setState({ userStatus: "graduated" });
            } else if (res.response.training_started) {
              this.setState({ userStatus: "continueTraining" });
            } else {
              this.setState({ userStatus: "startTraining" });
            }
          }
        });
      })
    );
    this.getUserProgress();
  }

  render() {
    const {
      unreadMessageCount,
      appId,
      offers,
      noAgent,
      trainingComplete,
      userStatus,
    } = this.state;

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: "y",
      },
      buttons: ["share", "close"],
      caption: "",
      share: {
        tpl: renderToString(
          <SharingPopup
            url={`https://front.travpromobile.com/${appId}/Legoland_offer.pdf`}
          />
        ),
      },
    };

    const close = () => {
      this.setState({
        noAgent: false,
      });
    };

    return (
      <div className="homeContainer">
        {bgVideo && <BackVideo />}
        <div className="bgHome" />
        <div className="buttonWrapper">
          {i18n.translate("reportCard.download")}:
          <StoreButtons />
        </div>
        <LanguageSelect />
        <img src={`/${Logo}`} className="homeLogo" alt="logo" />
        <Spring
          from={{ transform: "translateY(30%)", opacity: 0 }}
          to={{ transform: "translateY(0%)", opacity: 1 }}
        >
          {(props) => (
            <div className="homeView" style={props}>
              <div className="homeView__title">
                {Number(appId) == 852 && (
                  <h1>
                    <span className="translated">
                      Capital Mundial dos Parques Temáticos
                    </span>
                  </h1>
                )}
                {Number(appId) == 850 && (
                  <h1>
                    <span className="translated">
                      Capital Mundial de los Parques Temáticos
                    </span>
                  </h1>
                )}
                {Number(appId) == 1430 && (
                  <h1>
                    <span className="translated">
                      La Capitale Mondiale des Parcs d'Attractions
                    </span>
                  </h1>
                )}
                {Number(appId) == 743 && (
                  <h1>
                    The <br />
                    <span>Theme Park Capital</span>
                    <br /> of the World
                  </h1>
                )}
                {Number(appId) == 1344 && (
                  <h1>
                    Die <br />
                    <span>Themenpark-Hauptstadt</span>
                    <br /> der Welt
                  </h1>
                )}
                <div className="homeView__title--line" />
                <div className="homeView__title--action">
                  <form>
                    <Link
                      to="/main/search"
                      onClick={() => {
                        this.setQuery();
                      }}
                    >
                      <button type="submit" className="searchButton">
                        <FontAwesomeIcon icon={["fas", "search"]} />
                      </button>
                    </Link>
                    <input
                      type="text"
                      placeholder={i18n.translate("general.search")}
                      onChange={(e) => {
                        const { value } = e.target;
                        this.setState({ query: value });
                      }}
                    />
                    <Link
                      to="/main/search"
                      onClick={() => {
                        this.setQuery();
                      }}
                    >
                      <button type="submit" className="searchButton">
                        <FontAwesomeIcon icon={["fas", "search"]} />
                      </button>
                    </Link>
                  </form>
                  <div className="homepage__buttons">
                    {userStatus === "graduated" && (
                      <Link to="/main/offers" className="offers">
                        <p>{i18n.translate("nav.offers")}</p>
                      </Link>
                    )}
                    {userStatus !== "graduated" && (
                      <a
                        className="offers"
                        onClick={() => {
                          this.openPopup();
                        }}
                      >
                        <FontAwesomeIcon icon={["fas", "lock"]} />{" "}
                        <p>{i18n.translate("nav.offers")}</p>
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <SweetAlert
                title=""
                show={offers}
                html
                text={i18n.translate("general.unlock")}
                customClass="noAgent"
                showConfirmButton={false}
                cancelButtonText={i18n.translate("general.close")}
                showCancelButton
                onConfirm={() => {
                  this.closePopup();
                }}
                onCancel={() => {
                  this.closePopup();
                }}
                onEscapeKey={() => {
                  this.closePopup();
                }}
                onOutsideClick={() => {
                  this.closePopup();
                }}
              />
            </div>
          )}
        </Spring>
        <div className="top-bar" />
        <div className="bottom-bar" />
        {/* <SweetAlert
          title="This feature is Coming Soon"
          show={noAgent}
          imageUrl={Logo2}
          imageWidth="50rem"
          imageHeight="50rem"
          html
          text=""
          customClass="noAgent"
          showConfirmButton={false}
          cancelButtonText={i18n.translate('general.close')}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        /> */}

        <NotificationSlider appId={appId} middle right />
      </div>
    );
  }
}
